import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.div`
  padding: 0 80px;

  @media (max-width: 768px) {
    padding: 0 32px;
  }

  @media (max-width: 480px) {
    padding: 0 16px;
  }
`

const Section = styled.section`
  padding: 48px 24px;

  @media (max-width: 768px) {
    padding: 32px 0;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
`;

const Card = styled.div`
  background-color: #fafafa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e9e8e8;
  text-align: center;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 100%;
  min-height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover{
    scale: 1.05;
    transition: 1.5s;
  }

  @media (max-width: 480px) {
    padding: 12px;
    font-size: 0.9rem;
    min-height: 64px;
  }
`;

export default function Services() {
  return (
    <Container>
      <Section id="servicos">
        <Title>Serviços</Title>
        <Grid>
          <StyledLink to="/consultoriaEspecializada">
            <Card>Consultoria especializada</Card>
          </StyledLink>
          <StyledLink to="/gerenciamentoObras">
            <Card>Gerenciamento de Obras</Card>
          </StyledLink>
          <StyledLink to="/fiscalizacaoTecnica">
            <Card>Fiscalização técnica</Card>
          </StyledLink>
          <StyledLink to="/planejamentoEcontrole">
            <Card>Planejamento e controle</Card>
          </StyledLink>
        </Grid>
      </Section>
    </Container>
  );
}